import { RSAA } from 'redux-api-middleware'
import { API_URL } from '@severed-links/common.redherrings-constants'

// Use the existing authentication (and mobile Android URL) middleware.
export const continuationRequest = (contest, operation, body) => ({
  [RSAA]: {
    endpoint: `${API_URL}${contest}Admin/Continuation/${operation}`,
    method: body ? 'POST' : 'GET',
    ...(body ? { body: JSON.stringify(body) } : {}),
    types: ['SURVIVOR_CONTINUATION_REQUEST', 'SURVIVOR_CONTINUATION_SUCCESS', 'SURVIVOR_CONTINUATION_FAILURE'],
  },
})
export const continuationResult = action => {
  const payload = action?.payload?.response || action?.payload
  if (action?.error || payload?.messageType === 'error' || !payload) throw new Error(payload?.message || 'Unable to update continuation. Reload and try again.')
  return payload
}
